import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { StandingState, ValueStore } from "../store/constants";
import { StandingAll } from "../client/api";

export const selectStandingSlice = (s: RootState): StandingState => s.standing;

export const selectStandings = createSelector(
  selectStandingSlice,
  (st): ReadonlyArray<ValueStore<StandingAll>> => st.value
);

export const makeSelectStandingsByLeagueId = (leagueId: number | string) =>
  createSelector(selectStandings, (list) =>
    list.find((x) => String(x.id) === String(leagueId))?.response
  );




